import { render, staticRenderFns } from "./RawHddInfo.vue?vue&type=template&id=0bb483cd&scoped=true"
import script from "./RawHddInfo.vue?vue&type=script&lang=js"
export * from "./RawHddInfo.vue?vue&type=script&lang=js"
import style0 from "./RawHddInfo.vue?vue&type=style&index=0&id=0bb483cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb483cd",
  null
  
)

export default component.exports